var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-loading',{attrs:{"is-full-page":_vm.scrull,"active":_vm.isLoading,"can-cancel":_vm.cancelable,"scroll":_vm.scrull}}),(_vm.noData)?_c('p',{staticClass:"subtitle"},[_vm._v("Nothing Loaded Yet Hoss.")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }